// sites on test count
export const loadSitesOnTestCountStart = (params) => {
  return { type: "LOAD_SITES_ON_TEST_COUNT_START", ...params };
};

export const loadSitesOnTestCountSuccess = (params) => {
  return { type: "LOAD_SITES_ON_TEST_COUNT_SUCCESS", ...params, };
};

export const loadSitesOnTestCountFailed = (params) => {
  return { type: "LOAD_SITES_ON_TEST_COUNT_FAILED", ...params };
};

export const loadSitesOnTestCountCancel = (params) => {
  return { type: "LOAD_SITES_ON_TEST_COUNT_CANCEL", ...params };
};

// sites on test count live refresh
export const loadSitesOnTestCountRefreshStart = (params) => {
  return { type: "LOAD_SITES_ON_TEST_COUNT_REFRESH_START", ...params };
};

export const loadSitesOnTestCountRefreshSuccess = (params) => {
  return { type: "LOAD_SITES_ON_TEST_COUNT_REFRESH_SUCCESS", ...params, };
};

export const loadSitesOnTestCountRefreshFailed = (params) => {
  return { type: "LOAD_SITES_ON_TEST_COUNT_REFRESH_FAILED", ...params };
};

export const loadSitesOnTestCountRefreshCancel = (params) => {
  return { type: "LOAD_SITES_ON_TEST_COUNT_REFRESH_CANCEL", ...params };
};

// sites on test
export const loadSitesOnTestStart = (params) => {
  return { type: "LOAD_SITES_ON_TEST_START", ...params };
};

export const loadSitesOnTestSuccess = (params) => {
  return { type: "LOAD_SITES_ON_TEST_SUCCESS", ...params, };
};

export const loadSitesOnTestFailed = (params) => {
  return { type: "LOAD_SITES_ON_TEST_FAILED", ...params };
};

export const loadSitesOnTestCancel = (params) => {
  return { type: "LOAD_SITES_ON_TEST_CANCEL", ...params };
};

// sites on test live refresh
export const loadSitesOnTestRefreshStart = (params) => {
  return { type: "LOAD_SITES_ON_TEST_REFRESH_START", ...params };
};

export const loadSitesOnTestRefreshSuccess = (params) => {
  return { type: "LOAD_SITES_ON_TEST_REFRESH_SUCCESS", ...params, };
};

export const loadSitesOnTestRefreshFailed = (params) => {
  return { type: "LOAD_SITES_ON_TEST_REFRESH_FAILED", ...params };
};

export const loadSitesOnTestRefreshCancel = (params) => {
  return { type: "LOAD_SITES_ON_TEST_REFRESH_CANCEL", ...params };
};

// clear sites on test
export const clearSitesOnTest = (params) => {
  return { type: "CLEAR_SITES_ON_TEST", ...params };
};